<template>
	<div>
		<v-app dark class="background">
			<ToolBar :title="title" @menu-open="show_drawer = true">
			</ToolBar>

			<FileOpenerFallback></FileOpenerFallback>
			<AppVersionChecker></AppVersionChecker>

			<v-content id="gravity-content">
				<AppStatusMessage></AppStatusMessage>
				<router-view></router-view>
			</v-content>

			<Launcher
				:dialog="launcher.dialog && launcher.version === 1"
				:jd_id="launcher.jd_id"
				:parameters="launcher.parameters"
				:param="launcher.param"
				:parent_jr_id="launcher.parent_jr_id"
				@close="closeLauncher()">
			</Launcher>

			<LauncherV2
				:dialog="launcher.dialog && launcher.version === 2"
				:jd_id="launcher.jd_id"
				:parameters="launcher.parameters"
				:param="launcher.param"
				:parent_jr_id="launcher.parent_jr_id"
				:direct_edit="launcher.direct_edit"
				@close="closeLauncher()"
				@remove-dupli-data="launcher.parent_jr_id = null;
														launcher.parameters = {}">
			</LauncherV2>

			<EventDial></EventDial>
			<Toaster></Toaster>
			<ModalAsset></ModalAsset>

			<SwitchPlayer
				:filepath="switch_player_filepath"
				@close="switch_player_filepath = null">
			</SwitchPlayer>
		</v-app>
	</div>
</template>

<script>
import colors from '@/App_colors.js'
import EventDial from '@/App_event_dial.vue'
import Toaster from '@/App_toaster.vue'
import ToolBar from '@/App_toolBar.vue'
import FileOpenerFallback from '@/file_opener_fallback.vue'
import AppVersionChecker from '@/app_version_checker.vue'
import AppStatusMessage from '@/App_status_message.vue'
import Launcher from '@/pages/maestro/launcher/launcher.vue'
import LauncherV2 from '@/pages/maestro/launcher/launcher_v2.vue'
import ModalAsset from '@/components/globals/modal_asset.vue'
import SwitchPlayer from '@/components/switch_player.vue'

const envPrefix = process.env.ENV_URLS && process.env.ENV_URLS !== 'production' ? `[${process.env.ENV_URLS}] ` : ''

export default {
	name: 'App',
	components: {
		EventDial,
		Toaster,
		ToolBar,
		FileOpenerFallback,
		AppVersionChecker,
		Launcher,
		LauncherV2,
		AppStatusMessage,
		ModalAsset,
		SwitchPlayer
	},
	data () {
		return {
			title: null,
			show_drawer: false,
			launcher: {
				dialog: false,
				version: 2,
				jd_id: 0,
				parameters: {},
				param: {},
				parent_jr_id: null,
				direct_edit: false
			},
			switch_player_filepath: null
		}
	},
	watch: {
		'$route' (route) {
			this.onRouteChange(route)
		}
	},
	methods: {
		onRouteChange (route) {
			this.title = route.meta.label
		},
		closeLauncher () {
			this.launcher.dialog = false
			this.launcher.jd_id = 0
			this.launcher.parameters = {}
			this.launcher.param = {}
			this.launcher.parent_jr_id = null
			let routeQuery = JSON.parse(JSON.stringify(this.$route.query))
			delete routeQuery.launcher_jd
			delete routeQuery.launcher_jr
			this.$router.replace({
				path: this.$route.path,
				name: this.$route.name,
				params: this.$route.params,
				query: routeQuery
			}).catch(error => {
				console.error(error.message)
			})
		},
		clean_oidc_localstorage () {
			try {
				for (let i = 0; i < window.localStorage.length; i++) {
					const key = localStorage.key(i)
					if (key.startsWith('oidc.')) {
						let value = JSON.parse(localStorage.getItem(key))
						if (value.created) {
							let creationDate = new Date(value.created * 1000)
							let yesterday = Date.now() - 86400000
							if ((yesterday - creationDate) > 0) {
								localStorage.removeItem(key)
							}
						}
					}
				}
			} catch (error) {
				console.log(error)
			}
		}
	},
	created () {
		this.clean_oidc_localstorage()
		this.$vuetify.theme = colors.dark
		let user = this.$cookies.get('user')
		this.$store.commit('set_user', user)
		require('./App_status')
	},
	mounted () {
		this.onRouteChange(this.$route)
		this.$Bus.$on('title_change', (title) => {
			this.title = title || this.$route.meta.label
			this.$nextTick(() => {
				document.title = envPrefix + title + ' - Gravity'
			})
		})

		this.$Bus.$on('launcher', (launcher) => {
			if (launcher) {
				if (launcher.version) {
					// window.localStorage.setItem('launcher_version', launcher.version)
					this.launcher.version = parseInt(launcher.version) || 2
				}
				// else {
				// 	let version = window.localStorage.getItem('launcher_version')
				// 	if (version) this.launcher.version = parseInt(version) || 2
				// }
				this.launcher.parameters = launcher.parameters
				this.launcher.param = launcher.param
				this.launcher.jd_id = launcher.jd_id
				this.launcher.parent_jr_id = launcher.parent_jr_id
				this.launcher.direct_edit = launcher.direct_edit
				this.launcher.dialog = true
			}
		})
		this.$router.onReady(() => {
			let routeQuery = this.$route.query
			let msg = {}
			if (routeQuery.launcher_jd) msg.jd_id = parseInt(routeQuery.launcher_jd)
			if (routeQuery.launcher_jr) {
				msg.parent_jr_id = parseInt(routeQuery.launcher_jr)
				msg.direct_edit = true
			}
			if (msg.jd_id || msg.parent_jr_id) this.$Bus.$emit('launcher', msg)
		})
		this.$Bus.$on('switch_player', (filepath) => {
			this.switch_player_filepath = filepath
		})
	}
}
</script>

<style lang="stylus">
@import "./App_main.styl"
@import "./App_treeview.styl"
@import "./App_inputs.styl"
@import "./tabulator.styl"
@import "./grv_inputs.styl"

@font-face
	font-family: "Roboto"
	font-weight: 400
	font-style: normal
	font-display: auto
	unicode-range: U+000-5FF
	src: local("Roboto"), url("/static/fonts/Roboto-Regular.woff2") format("woff2"), url("/static/fonts/Roboto-Regular.woff") format("woff")

</style>



// WEBPACK FOOTER //
// src/App.vue